import { configureStore } from '@reduxjs/toolkit';
import { createLandingApi } from '../api';
import { landingSlice } from './landingSlice';
import { dictionariesSlice } from './dictionariesSlice';
import { userSlice } from './userSlice';
import { IPreloadedState, TCreateStoreFunctionSignature } from '../types/redux';

export const createReduxStore = ((context, preloadedState: IPreloadedState, devTools) => {
  const landingApi = createLandingApi(context);

  return configureStore({
    reducer: {
      [landingApi.reducerPath]: landingApi.reducer,
      [landingSlice.name]: landingSlice.reducer,
      [dictionariesSlice.name]: dictionariesSlice.reducer,
      [userSlice.name]: userSlice.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        //FIXME отключил предупреждение сериализации - так как редукс ругается что передаем реакт-ref из событий
        //https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
        serializableCheck: {
          ignoreActions: true,
        },
        thunk: { extraArgument: context },
      }).concat(landingApi.middleware),
    preloadedState,
    devTools,
  });
}) satisfies TCreateStoreFunctionSignature;
